const FromArr = [{
	title: "类型名称：",
	inputtype: "input",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "text",
	placeholder: "请输入",
	width: 192,
	height: 32,
	disabled: false,
	marginLeft: 24,
	marginTop: 22,
	displayVal: "inline-block",
	fontWeightVal: 500,
	modelvalue: ''
}, {
	title: "价格形式：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "请选择",
	width: 192,
	height: 32,
	disabled: false,
	marginLeft: 24,
	marginTop: 28,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	modelvalue: ''
}, {
	title: "LEVEL1：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "请选择",
	width: 192,
	height: 32,
	disabled: false,
	marginLeft: 24,
	marginTop: 28,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	modelvalue: ''
}, {
	title: "LEVEL3：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "请选择",
	width: 192,
	height: 32,
	disabled: false,
	marginLeft: 24,
	marginTop: 28,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	modelvalue: ''
}, {
	title: "经销商：",
	inputtype: "input",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "text",
	placeholder: "请输入",
	width: 192,
	height: 32,
	disabled: false,
	marginLeft: 24,
	marginTop: 28,
	displayVal: "inline-block",
	fontWeightVal: 500,
	modelvalue: ''
}, {
	title: "医院：",
	inputtype: "input",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "text",
	placeholder: "请输入",
	width: 192,
	height: 32,
	disabled: false,
	marginLeft: 24,
	marginTop: 28,
	displayVal: "inline-block",
	fontWeightVal: 500,
	modelvalue: ''
}]
export default FromArr;